// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { Button, Icon } from '@plesk/ui-library';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Tooltip } from 'jsw';

const AdvisorButton = ({
    id,
    link = '#',
    target = '_self',
    title = '',
    description = '',
    handler = '',
    onOpenModule = () => {},
}) => {
    const handleFocus = e => {
        const el = e.currentTarget;
        const rect = el.getBoundingClientRect();
        Tooltip.tooltipX = rect.left + window.scrollX + (rect.width / 2);
        Tooltip.tooltipY = rect.top + window.scrollY + (rect.height / 2);
        const text = el.getAttribute('data-description');
        Tooltip.init(el, { text });
        Tooltip.set({ element: el, config: { text } });
    };

    const handleBlur = () => {
        Tooltip.hide();
    };

    const handleKeyDown = e => {
        if (e.key === 'Enter') {
            const button = e.currentTarget.querySelector('button, [role="button"], a');
            if (button) {
                button.click();
                e.preventDefault();
            }
        }
    };

    return (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        <li
            id={`extNavHeader-${id}`}
            className={classNames('main-header-navbar-nav__item', `main-header-navbar-nav__item--${id}`)}
            data-description={description}
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            tabIndex={0}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
        >
            <Button
                component="a"
                onClick={() => onOpenModule && onOpenModule(handler)}
                href={link}
                tabIndex={-1}
                target={target}
                icon={<Icon src={require('icons/16/plesk/top-advisor.svg')} alt={title} />}
                ghost
            />
        </li>
    );
};

AdvisorButton.propTypes = {
    id: PropTypes.string.isRequired,
    link: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    handler: PropTypes.string,
    onOpenModule: PropTypes.func,
};

export default AdvisorButton;
